import React, { useState, useEffect } from 'react';
import { Table, Button, Form, Input, Select, Typography, Empty } from 'antd';



import CRUDE_TipiSsilokVSotsSetyakh from '../../../objects/TipiSsilokVSotsSetyakh/crude'
import CRUDE_SotsSeti from '../../../objects/SotsSeti/crude'
import "./index.css"
import Icofont from 'react-icofont';

import tikTokIcon from '../../../icons/tik_tok.svg' // relative path to image 

const { Option } = Select;
const { Link } = Typography;

var _ = require('lodash');

const SocialIcon = (key) => {
    switch (key.toLowerCase()) {
        case "facebook":
            return (<Icofont icon="facebook" style={{ paddingRight: "5px" }} />);
        case "instagram":
            return (<Icofont icon="instagram" style={{ paddingRight: "5px" }} />);
        case "tiktok":
            return (<img src={tikTokIcon} style={{ width: "19px", paddingRight: "5px" }} />);
        case "vkontakte":
            return (<Icofont icon="vk" style={{ paddingRight: "5px" }} />);
        case "ok":
            return (<Icofont icon="odnoklassniki" style={{ paddingRight: "5px" }} />);
        default:
            return (<Icofont icon="link" style={{ paddingRight: "5px" }} />);
    }
};
export function SsilkiItem(props) {

    const { auth, object, onChange, value } = props;

    const [links, setLinks] = useState((value) ? value : []);
    const [linkText, setLinkText] = useState("");
    const [linkType, setLinkType] = useState(1);

    useEffect(() => {
        triggerChange(links);
    }, [links]);

    const triggerChange = (changedValue) => {
        if (onChange) {
            onChange([
                ...changedValue,
            ]);
        }
    };

    const [sotsSet, setSotsSet] = useState([]);
    // const sotsSet = useSelector(REDUX_SotsSeti.selector.array);
    useEffect(() => {
        CRUDE_SotsSeti.read(auth, (data) => {
            if (data.length > 0) {
                setSotsSet(data);
                // dispatch(REDUX_SotsSeti.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
    }, []);
    const sotsSetOptions = sotsSet.map((i) => <Option key={i.ID} value={i.ID}>{SocialIcon(i.nazvanie)}{i.nazvanie}</Option>);

    const changeLinkText = (e) => {
        setLinkText(e.target.value);
        // suggestion ?
    };
    const changeLinkType = (value) => {
        setLinkType(value);
    };
    const appendLink = () => {
        var social = sotsSet.find(e => e.ID === linkType);
        if (social && linkText) {
            setLinks([...links.filter(e => e.ssilka !== linkText), {
                ssilka: linkText,
                ssilkaVSotsSetiID: (object) ? object.ID : undefined,
                sotsSetID: linkType,
                sotsSet: social,
            }]);
            setLinkText("");
        }
    };
    const deleteLink = (record) => {
        setLinks(links.filter(e => e.ssilka !== record.ssilka));
    };
    const selectBefore = (
        <Select style={{ width: "120px" }} defaultValue={1} onChange={changeLinkType}
            showSearch
            filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {sotsSetOptions}
        </Select>
    );
    const columns = () => {
        var c = [];
        c.push({
            width: "35px",
            title: 'Тип ссылки',
            render: (text, record) => {
                return (
                    <div>
                        {SocialIcon(record.sotsSet.nazvanie)}
                    </div>
                );
            },
            key: 'tipSsilki',
        });
        c.push({
            title: 'Ссылка',
            ellipsis: true,
            render: (text, record) => {
                return (
                    <div>
                        <Link href={record.ssilka} target="_blank">
                            {record.ssilka}
                        </Link>
                    </div>
                );
            },
            key: 'ssilka',
        });
        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                return (
                    <Button type="text" style={{ padding: "4px 4px" }} onClick={() => deleteLink(record)}><Icofont icon="close" /></Button>
                );
            },
        });

        return c;
    };

    return (<>
        <div style={{ marginBottom: 16 }}>
            <Input value={linkText} onChange={changeLinkText} addonBefore={selectBefore} addonAfter={<div onClick={appendLink} style={{ cursor: "pointer" }}><Icofont icon="plus" /></div>} />
        </div>
        <div>
            <Table
                showHeader={false}
                columns={columns()}
                pagination={false}
                dataSource={links}
                locale={{ emptyText: <Empty description={"Нет ссылок"}></Empty> }}
                size="small"
                rowKey={() => _.uniqueId()} />
        </div>
    </>);
}
export default function SsilkiVSotsSetyakh(props) {
    const { auth, object, context } = props;
    const [tipSsilki, setTipSsilki] = useState([]);
    // const tipSsilki = useSelector(REDUX_TipiSsilokVSotsSetyakh.selector.array);
    useEffect(() => {
        CRUDE_TipiSsilokVSotsSetyakh.read(auth, (data) => {
            if (data.length > 0) {
                setTipSsilki(data);

                // dispatch(REDUX_TipiSsilokVSotsSetyakh.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
    }, []);
    const tipSsilkiOptions = tipSsilki.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    return (
        <>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={(context && context.ID) ? {
                    ...object,
                    meropriyatieID: context.ID,
                } : {
                    ...object,
                }}
            >
                {(object && object.ID) && <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"ID"}
                >
                    <Input disabled />
                </Form.Item>}
                <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"meropriyatieID"}
                    label={"Мероприятие"}
                >
                    <Input disabled />
                </Form.Item>
                <Form.Item label={"Название"}
                    name="nazvanie"
                    rules={[
                        { required: true, message: 'Пожалуйста, введите название!' }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Тип ссылки"
                    name="tipSsilkiID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите тип ссылки!' }]}
                >
                    <Select showSearch>
                        {tipSsilkiOptions}
                    </Select>
                </Form.Item>
                <Form.Item label={"Ссылки"}
                    name="ssilkaSotsSetiSsilkaVSotsSeti"
                    rules={[{ required: true, message: 'Пожалуйста, укажите ссылки!' }]}
                >
                    <SsilkiItem auth={auth} object={object} />
                </Form.Item>
            </Form>
        </>
    );
}
